/** Semver-like pattern: major.minor.patch (e.g. 1.0.0) */
export const RELEASE_VERSION_PATTERN = /^\s*(\d+)\.(\d+)\.(\d+)\s*$/

/** Increments the patch segment of a semver string (e.g. "1.2.3" → "1.2.4"). Returns empty string if the version does not match semver format. */
export function patchVersion(version: string): string {
	const match = version.trim().match(/^(\d+)\.(\d+)\.(\d+)/)
	if (!match) return ''
	return `${match[1]}.${match[2]}.${Number(match[3]) + 1}`
}

/** Strips a trailing -SNAPSHOT suffix from a version string. */
export function toReleaseVersion(version: string | undefined): string {
	if (!version?.trim()) return ''
	const trimmed = version.trim()
	return trimmed.endsWith('-SNAPSHOT') ? trimmed.slice(0, -'-SNAPSHOT'.length) : trimmed
}

/** Increments the patch segment and appends -SNAPSHOT (e.g. "1.2.3" → "1.2.4-SNAPSHOT"). */
export function toDevelopmentVersion(version: string): string {
	const trimmed = version.trim()
	const match = trimmed.match(RELEASE_VERSION_PATTERN)
	if (match) {
		return `${match[1]}.${match[2]}.${Number(match[3]) + 1}-SNAPSHOT`
	}
	return version
}

/** Compares two semver strings. Returns negative if a < b, positive if a > b, 0 if equal. Non-semver strings sort last. */
export function compareSemver(a: string, b: string): number {
	const ma = a.trim().match(RELEASE_VERSION_PATTERN)
	const mb = b.trim().match(RELEASE_VERSION_PATTERN)
	if (!ma && !mb) return 0
	if (!ma) return 1
	if (!mb) return -1
	for (let i = 1; i <= 3; i++) {
		const diff = Number(ma[i]) - Number(mb[i])
		if (diff !== 0) return diff
	}
	return 0
}

/** Finds the highest semver version from an array of version strings. Returns undefined if the array is empty or contains no valid semver versions. */
export function findLatestVersion(versions: string[]): string | undefined {
	let latest: string | undefined
	for (const v of versions) {
		if (!RELEASE_VERSION_PATTERN.test(v.trim())) continue
		if (!latest || compareSemver(v, latest) > 0) latest = v.trim()
	}
	return latest
}
